import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";
import { create } from "zustand";

interface DataModel {
  actionId?: string;
  shuntingUnit?: ShuntingUnit;
  setDetailPanelData: (newActionId: string, newShuntingUnit: ShuntingUnit) => void;
  clearDetailPanelData: () => void;
}

export const useDetailPanelData = create<DataModel>((set) => ({
  setDetailPanelData: (newActionId, newShuntingUnit) =>
    set(() => ({
      actionId: newActionId,
      shuntingUnit: newShuntingUnit,
    })),
  clearDetailPanelData: () => set(() => ({ actionId: undefined, shuntingUnit: undefined })),
}));
